function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M15,2.48A8.43,8.43,0,0,0,8.78,0,8.88,8.88,0,0,0,0,8.94a8.63,8.63,0,0,0,8.65,8.64H8.8A8.83,8.83,0,0,0,15,2.48ZM1.58,8.92A7.29,7.29,0,0,1,8.8,1.58h.13a7,7,0,0,1,4.34,1.5.83.83,0,0,0-.12.08L3.06,13.25A7.36,7.36,0,0,1,1.58,8.92ZM8.78,16H8.65a7,7,0,0,1-4.32-1.47l10.1-10.1a.53.53,0,0,0,.06-.1A7.24,7.24,0,0,1,8.78,16Z"
})));

var SvgNotAllowed = function SvgNotAllowed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 17.58 17.58",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotAllowed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not-allowed.9ad99fa9.svg";
export { ForwardRef as ReactComponent };